<template>
  <div v-loading="contentLoading">
    <div class="title">
      基本信息
    </div>
    <el-form ref="Form" :model="form" label-width="0" :show-message="false">
      <table cellspacing="0" cellpadding="0" style="width: 100%" class="ReserveOrderTable">
        <tr>
          <td class="tableLabel">申请编号</td>
          <td class="tableContent">{{form.invoiceApplicationNo}}</td>
          <td class="tableLabel">申请状态</td>
          <td :colspan="3" class="tableContent">
            <span v-if="form.status === 0">草稿</span>
            <span v-if="form.status === 1">已提交</span>
            <span v-if="form.status === 2">已处理</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">客户名称</td>
          <td class="tableContent">
            <el-input v-model="form.customerName" placeholder="客户名称" disabled>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="!edit || !customerEditAuth"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
            <!-- <el-input v-model.trim="form.customerName" :disabled="!edit" placeholder="客户名称"/> -->
          </td>
          <td class="tableLabel">客户税号</td>
          <td class="tableContent">
            <el-input v-model="form.invoiceVATNO" :disabled="!edit" placeholder="客户税号"/>
          </td>
          <td class="tableLabel">银行账号</td>
          <td class="tableContent">{{form.invoiceAccounts}}</td>
        </tr>
        <tr>
          <td class="tableLabel">客户编号</td>
          <td class="tableContent">{{form.customerNo}}</td>
          <td class="tableLabel">地址</td>
          <td class="tableContent">
            <el-input v-model="form.invoiceAddress" :disabled="!edit" placeholder="地址"/>
          </td>
          <td class="tableLabel">邮箱</td>
          <td class="tableContent">
            <el-input v-model="form.email" :disabled="!edit" placeholder="邮箱"/>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">财务凭证号</td>
          <td class="tableContent">{{form.financialVouchers}}</td>
          <td class="tableLabel">出厂编号</td>
          <td class="tableContent">
            <div ref="factoryNoContainer" class="factory-no-container">
              <div class="factory-no-text">
                <el-input v-model="form.factoryNo" :disabled="!edit" placeholder="出厂编号"/>
              </div>
              <div v-if="factoryNoOverflow" class="view-more-link" @click="showViewMoreDialog(form.factoryNo)">
                查看更多
              </div>
            </div>
          </td>
          <td class="tableLabel">申请人</td>
          <td class="tableContent">{{form.creatorName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">申请日期</td>
          <td class="tableContent">{{form.createTime}}</td>
          <td class="tableLabel">提交日期</td>
          <td class="tableContent">{{form.submitTime}}</td>
          <td class="tableLabel">通过日期</td>
          <td class="tableContent">{{form.passTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">发票类型</td>
          <td class="tableContent">
            <el-form-item prop="invoiceType">
              <el-select v-model="form.invoiceType" :disabled="!edit">
                <el-option label="全电专" :value="'05'"/>
                <el-option label="全电普" :value="'06'"/>
              </el-select>
            </el-form-item>
          </td>
          <td class="tableLabel">发票状态</td>
          <td class="tableContent">
            <el-form-item prop="invoiceStatus">
              <el-select v-model="form.invoiceStatus" :disabled="!edit">
                <el-option label="蓝票" :value="'1'"/>
                <el-option label="红票" :value="'2'"/>
              </el-select>
            </el-form-item>
          </td>
          <td class="tableLabel">冲销金税票号</td>
          <td class="tableContent">
            <el-form-item
                prop="referencecode"
                :rules="[{ required: form.invoiceStatus === '2', message: '请填写红字发票号码', trigger: 'blur' }]">
              <el-input
                  v-model="form.referencecode"
                  :disabled="!edit || form.invoiceStatus === '1'"
                  placeholder="请输入红字发票号码"/>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="form.invoiceStatus === '2'">
          <td class="tableLabel">红字冲销原因</td>
          <td class="tableContent">
            <el-select v-model="form.offsetReason" :disabled="!edit" prop="offsetReason">
              <el-option label="开票错误" :value="'1'"/>
              <el-option label="销售退回" :value="'2'"/>
              <el-option label="销售折让" :value="'3'"/>
              <el-option label="发票管理问题" :value="'4'"/>
            </el-select>
          </td>
          <td class="tableLabel">红冲方式</td>
          <td class="tableContent">
            <el-select v-model="form.offsetMethod" :disabled="!edit">
              <el-option label="全部红冲" :value="'1'"/>
              <el-option label="部分红冲" :value="'2'"/>
            </el-select>
          </td>
          <td class="tableLabel">红字通知单</td>
          <td class="tableContent">
            <el-input v-model="form.offsetNoticeNo" :disabled="!edit"/>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">开票不含税金额</td>
          <td class="tableContent">{{form.totalNetPrice}}</td>
          <td class="tableLabel">税额</td>
          <td class="tableContent">{{form.totalTaxPrice}}</td>
          <td class="tableLabel">开票金额</td>
          <td class="tableContent">{{form.invoiceTotalAmount}}</td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tableContent" colspan="6">
            <el-input v-model="form.note" :disabled="!edit" placeholder="备注"/>
          </td>
        </tr>
      </table>
    </el-form>

    <div>
      <div v-if="deliveryList.length > 0">
        <div
            style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; align-items: center; ">
          <div>关联发货单列表</div>
        </div>
        <div v-show="!deliveryListCollapsed">
          <el-form ref="deliveryForm" :model="{ deliveryList: deliveryList }" label-width="0" :show-message="false">
            <el-table
                :data="deliveryList"
                :border="true"
                stripe
                row-key="id"
                :max-height="600">
              <el-table-column type="index" align="center" label="#"/>
              <el-table-column prop="billNo" align="center" label="单号" width="100"/>
              <el-table-column prop="rowIndex" align="center" label="行项" width="100"/>
              <el-table-column prop="materialNo" align="center" label="物料号"/>
              <el-table-column prop="materialName" align="left" label="物料名称" width="400"/>
              <el-table-column prop="quantity" align="center" label="数量" width="120">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'deliveryList.' + scope.$index + '.quantity'"
                      :rules="ruleValidate.quantity">
                    <table-input
                        v-model="scope.row.quantity"
                        type="number"
                        :disabled="!edit || isEdit"
                        placeholder="请输入"
                        @change="calculateInvoicAmount(scope.row, $event, 'quantity')"/>
                    <!-- <el-input
                        v-model="scope.row.quantity"
                        style="width: 100%"
                        :disabled="!edit || isEdit"
                        @change="calculateInvoicAmount(scope.row, $event, 'quantity')"/> -->
                    <!-- :max="edit ? scope.row.initQuantity > 0 ? scope.row.initQuantity : -1 : scope.row.quantity"
                      :min="edit ? scope.row.initQuantity > 0 ? 1 : scope.row.initQuantity : scope.row.quantity" -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="unitPrice" align="center" label="单价(含税)" width="150"/>
              <el-table-column prop="totalNetPrice" align="center" label="总价(不含税)" width="150"/>
              <el-table-column prop="totalPrice" align="center" label="总价(含税)" width="150"/>
              <el-table-column prop="taxRate" align="center" label="税率" width="100">
                <template slot-scope="scope">
                  <el-form-item :prop="'deliveryList.' + scope.$index + '.taxRate'">
                    <table-input
                        v-model="scope.row.taxRate"
                        type="number"
                        :disabled="!edit || isEdit"
                        placeholder="请输入"
                        @change="calculateInvoicAmount(scope.row, $event, 'taxRate')"/>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--            <el-table-column prop="softInfo" align="center" label="软著信息"/>-->
              <el-table-column
                  v-if="!(!edit || isEdit)"
                  label="操作"
                  width="140"
                  align="center"
                  fixed="right">
                <template slot-scope="scope">
                  <el-button
                      v-if="scope.row.quantity > 0"
                      type="text"
                      size="small"
                      :disabled="!edit || isEdit"
                      @click="splitDetail(scope.row, 'delivery')">
                    明细拆分
                  </el-button>
                  <el-button
                      :disabled="!edit || isEdit || (saleOrderList.length + deliveryList.length === 1)"
                      type="danger"
                      @click="deleteRow(scope.$index, 'delivery', scope.row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
      <div v-if="saleOrderList.length > 0">
        <div
            style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; align-items: center;">
          <div>关联销售订单列表</div>
        </div>
        <div v-show="!saleOrderListCollapsed">
          <el-form ref="saleOrderForm" :model="{ saleOrderList: saleOrderList }" label-width="0" :show-message="false">
            <el-table
                :data="saleOrderList"
                :border="true"
                stripe
                :max-height="600"
                row-key="id">
              <el-table-column type="index" align="center" label="#"/>
              <el-table-column prop="billNo" align="center" label="单号"/>
              <el-table-column prop="rowIndex" align="center" label="行项"/>
              <el-table-column prop="materialNo" align="center" label="物料号"/>
              <el-table-column prop="materialName" align="center" label="物料名称"/>
              <!--            <el-table-column prop="specification" align="center" label="规格型号"/>-->
              <!--            <el-table-column prop="manufacturerModel" align="center" label="厂家型号"/>-->
              <!--            <el-table-column prop="sapProductName" align="center" label="开票名称"/>-->
              <el-table-column prop="quantity" align="center" label="数量" width="120">
                <template slot-scope="scope">
                  <el-form-item
                      v-if="!(!edit || isEdit)"
                      :prop="'saleOrderList.' + scope.$index + '.quantity'"
                      :rules="ruleValidate.quantity">
                    <el-input
                        v-model="scope.row.quantity"
                        style="width: 100%"
                        :disabled="!edit || isEdit"
                        @change="calculateInvoicAmount(scope.row, $event, 'quantity')"/>
                    <!-- :max="edit ? scope.row.initQuantity > 0 ? scope.row.initQuantity : -1 : scope.row.quantity"
                      :min="edit ? scope.row.initQuantity > 0 ? 1 : scope.row.initQuantity : scope.row.quantity" -->
                  </el-form-item>
                  <template v-else>
                    {{scope.row.quantity}}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="unit" align="center" label="单位"/>
              <el-table-column prop="unitPrice" align="center" label="单价(含税)"/>
              <el-table-column prop="totalPrice" align="center" label="总价(含税)"/>
              <el-table-column prop="taxRate" align="center" label="税率" width="100">
                <template slot-scope="scope">
                  <el-form-item v-if="!(!edit || isEdit)" :prop="'saleOrderList.' + scope.$index + '.taxRate'">
                    <el-input
                        v-model="scope.row.taxRate"
                        :disabled="!edit || isEdit"
                        placeholder="请输入税率"
                        type="number"
                        @change="calculateInvoicAmount(scope.row, $event, 'taxRate')"/>
                  </el-form-item>
                  <template v-else>
                    {{scope.row.taxRate}}
                  </template>
                </template>
              </el-table-column>
              <!--            <el-table-column prop="softInfo" align="center" label="软著信息"/>-->
              <el-table-column
                  v-if="!(!edit || isEdit)"
                  label="操作"
                  width="140"
                  align="center"
                  fixed="right">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      size="small"
                      :disabled="!edit || isEdit"
                      @click="splitDetail(scope.row, 'sale')">
                    明细拆分
                  </el-button>
                  <el-button
                      :disabled="!edit || isEdit"
                      type="danger"
                      @click="deleteRow(scope.$index, 'saleOrder', scope.row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
        <div style="display: flex; align-items: center;">
          <div>开票信息</div>
        </div>
        <div style="display: flex; gap: 20px;">
          <div>不含税总金额：<span style="color: red;">￥{{form.detailsTotalNetPrice}}</span></div>
          <div>总税额：<span style="color: red;">￥{{form.detailsTotalTaxPrice}}</span></div>
          <div>总金额：<span style="color: red;">￥{{form.detailsInvoiceTotalAmount}}</span></div>
        </div>
      </div>
      <div>
        <div v-show="!detailsListCollapsed">
          <el-button
              v-if="edit && !isEdit"
              type="primary"
              style="margin-bottom: 5px; margin-right: 10px"
              @click="addInvoiceDetails">
            添加
          </el-button>
          <el-button
              v-if="edit && !isEdit"
              type="danger"
              style="margin-bottom: 5px"
              @click="batchDeleteDetails">
            一键删除
          </el-button>
          <div>
            <el-form ref="detailsForm" :model="form" label-width="0" :show-message="false">
              <el-table
                  :data="form.details"
                  :border="true"
                  stripe
                  row-key="rowKey"
                  :max-height="600"
                  :row-class-name="(row, index) => 'drag-target-row invoice-row'"
                  @selection-change="handleDetailsSelectionChange">
                <el-table-column type="selection" width="55" fixed="left"/>
                <el-table-column type="index" align="center" label="行项"/>
                <el-table-column prop="type" align="center" label="类型"/>
                <el-table-column prop="invoiceContent" align="center" label="开票名称" width="200">
                  <template slot-scope="scope">
                    <el-form-item
                        :prop="'details.' + scope.$index + '.invoiceContent'"
                        :rules="ruleValidate.invoiceContent">
                      <table-input
                          v-model="scope.row.invoiceContent"
                          :disabled="!edit"
                          placeholder="请输入开票名称"
                          @change="invoiceContentChange(scope.row)"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="materialNo" align="center" label="物料编号" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'details.' + scope.$index + '.materialNo'">
                  <el-input v-model="scope.row.materialNo" :disabled="!edit" placeholder="请输入物料编号"/>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="materialName" width="220" align="center" label="物料描述">
              <template slot-scope="scope">
                <el-form-item :prop="'details.' + scope.$index + '.materialName'">
                  <el-input
                      v-model="scope.row.materialName"
                      :disabled="!edit"
                      placeholder="请输入物料描述"/>
                </el-form-item>
              </template>
            </el-table-column> -->
                <el-table-column prop="specification" align="center" label="规格型号" width="200">
                  <template slot-scope="scope">
                    <table-input v-model="scope.row.specification" :disabled="!edit" placeholder="请输入规格型号"/>
                  </template>
                </el-table-column>
                <el-table-column prop="unit" align="center" label="单位" width="80">
                  <template slot-scope="scope">
                    <el-form-item :prop="'details.' + scope.$index + '.unit'">
                      <table-input v-model="scope.row.unit" :disabled="!edit" placeholder="请输入单位"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" align="center" label="数量" width="80">
                  <template slot-scope="scope">
                    <el-form-item
                        :prop="'details.' + scope.$index + '.quantity'"
                        :rules="ruleValidate.quantity">
                      <table-input
                          v-model="scope.row.quantity"
                          :disabled="!edit"
                          placeholder="请输入"
                          type="number"
                          @change="handleInvoiceCountChange(scope.row)"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="unitPrice" align="center" label="开票单价" width="100">
                  <template slot-scope="scope">
                    <el-form-item :prop="'details.' + scope.$index + '.unitPrice'" :rules="ruleValidate.unitPrice">
                      <table-input
                          v-model="scope.row.unitPrice"
                          :disabled="!edit"
                          placeholder="请输入"
                          type="number"
                          @change="handleInvoiceCountChange(scope.row)"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="totalNetPrice" align="center" label="开票总额(不含税)" width="150">
                  <template slot-scope="scope">
                    <el-form-item
                        :prop="'details.' + scope.$index + '.totalNetPrice'"
                        :rules="ruleValidate.totalNetPrice">
                      <table-input
                          v-model="scope.row.totalNetPrice"
                          :disabled="!edit"
                          placeholder="请输入"
                          type="number"
                          @change="calculateInvoiceTotalPrice(scope.row)"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="totalTaxPrice" align="center" label="税额" width="100">
                  <template slot-scope="scope">
                    <el-form-item
                        :prop="'details.' + scope.$index + '.totalTaxPrice'"
                        :rules="ruleValidate.totalTaxPrice">
                      <table-input
                          v-model="scope.row.totalTaxPrice"
                          :disabled="!edit"
                          placeholder="请输入"
                          type="number"
                          @change="calculateInvoiceTotalPrice(scope.row)"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="totalPrice" align="center" label="开票总额(含税)" width="150"/>
                <el-table-column prop="discount" align="center" label="折扣额(含税总额)" width="150">
                  <template slot-scope="scope">
                    <table-input
                        v-model="scope.row.discount"
                        :disabled="!edit"
                        placeholder="请输入"
                        type="number"
                        @change="calculateDiscountTaxPrice(scope.row)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="discountTaxPrice" align="center" label="折扣税额" width="150">
                  <template slot-scope="scope">
                    <table-input
                        v-model="scope.row.discountTaxPrice"
                        :disabled="!edit"
                        placeholder="请输入"
                        type="number"
                        @change="calcuteItemFinalPrice(scope.row)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="finalTotalPrice" align="center" label="实际开票金额(含税)" width="150"/>
                <el-table-column prop="finalTotalTaxPrice" align="center" label="实际税额" width="150"/>
                <el-table-column prop="finalTotalNetPrice" align="center" label="实际开票金额(不含税)" width="150"/>
                <el-table-column prop="taxRate" align="center" label="税率" width="100">
                  <template slot-scope="scope">
                    <el-form-item :prop="'details.' + scope.$index + '.taxRate'" :rules="ruleValidate.taxRate">
                      <table-input
                          v-model="scope.row.taxRate"
                          :disabled="!edit"
                          type="number"
                          placeholder="请输入"
                          @change="handleInvoiceTaxChange(scope.row)"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="taxTypeCode"
                    align="center"
                    label="税收分类名称"
                    width="150"
                    fixed="right">
                  <template slot-scope="scope">
                    <el-form-item
                        v-if="edit"
                        :prop="'details.' + scope.$index + '.taxTypeCode'"
                        :rules="ruleValidate.taxTypeCode">
                      <el-select
                          v-model="scope.row.taxTypeCode"
                          :disabled="!edit"
                          value-key="value"
                          filterable
                          remote
                          :remote-method="(query) => handleRemoteSearch(query, scope.row)"
                          :loading="scope.row.selectLoading"
                          placeholder="输入关键字查询"
                          @change="selectCode(scope.row)">
                        <el-option
                            v-for="item in scope.row.remoteOptions"
                            :key="item.taxTypeCode"
                            :value="item.taxTypeCode"
                            :label="item.taxTypeName"/>
                      </el-select>
                    </el-form-item>
                    <template v-else>
                      {{scope.row.taxTypeName}}
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="taxTypeCode"
                    align="center"
                    label="税收分类编码"
                    width="150"
                    fixed="right"/>
                <!-- <el-table-column prop="note" align="center" label="备注">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.note"
                    :disabled="!edit"
                    placeholder="请输入备注"/>
              </template>
            </el-table-column> -->
                <el-table-column
                    v-if="!(!edit || isEdit)"
                    label="操作"
                    width="100"
                    align="center"
                    fixed="right">
                  <template slot-scope="scope">
                    <el-button
                        :disabled="!edit || isEdit"
                        type="danger"
                        @click="deleteRow(scope.$index, 'detail', scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
        </div>
        <div>
          <div
              style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
            订单附件
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                style="display: inline-block; margin-bottom: 5px;">
              <el-button type="primary">
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table ref="payData1" border :data="form.accessoryList">
            <el-table-column type="index" align="center" label="#" width="55"/>
            <el-table-column prop="fileName" align="left" label="附件描述" width="750"/>
            <el-table-column label="下载" width="70" align="center">
              <template slot-scope="scope">
                <el-button type="primary" @click="download(scope.row)">下载</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
          </el-table>
        </div>
        <div style="text-align: right; padding-top: 10px;">
          <span v-if="edit || isEdit" slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
            <!--        <el-button type="primary" :loading="submitLoading" @click="submit">提交</el-button>-->
          </span>
        </div>
      </div>
      <!-- 查看更多弹窗 -->
      <el-dialog title="查看完整内容" :visible.sync="viewMoreDialogVisible" width="60%" @close="closeViewMoreDialog">
        <div class="view-more-content">
          {{viewMoreContent}}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeViewMoreDialog">关闭</el-button>
        </span>
      </el-dialog>
      <!-- 明细拆分弹窗 -->
      <detail-split-dialog
          :visible="splitDialogVisible"
          :detail-data="splitDetailData"
          :detail-type="splitDetailType"
          @close="splitDialogVisible = false"
          @confirm="handleSplitConfirm"/>
    </div>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import DetailSplitDialog from "./DetailSplitDialog.vue";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import TableInput from "./components/TableInput.vue";

  export default {
    name: "InvoiceApplicationPreview",
    components: {DetailSplitDialog, CustomerSelect, TableInput},
    data() {
      return {
        customerEditAuth: this.$auth(630),
        downLoadLoading: false,
        deliverySelection: [],
        saleOrderSelection: [],
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        edit: 1, // 是否是开票
        isEdit: false, // 是否是编辑
        rowKeyCounter: 0, // 行键值计数器，确保唯一性
        form: {
          pkId: 0,
          billNo: "",
          invoiceApplicationNo: "",
          customerId: "",
          customerName: "",
          customerNo: "",
          invoiceVATNO: "",
          invoiceAddress: "",
          invoiceAccounts: "",
          financialVouchers: "",
          email: "",
          invoiceTotalAmount: "",
          note: "",
          details: [],
          totalNetPrice: "",
          totalTaxPrice: "",
          invoiceType: "05",
          invoiceStatus: "1",
          referencecode: "",
          offsetReason: "",
          offsetMethod: "",
          offsetNoticeNo: "",
          cancelSign: false,

        },
        typeCodeList: [],
        deliveryList: [],
        saleOrderList: [],
        allList: [], // 存储所有关联明细，用于计算总金额
        // 列表折叠状态
        deliveryListCollapsed: false, // 关联发货单列表是否折叠
        saleOrderListCollapsed: false, // 关联销售订单列表是否折叠
        detailsListCollapsed: false, // 开票信息列表是否折叠
        // 选中的开票信息明细
        selectedDetails: [],
        // 查看更多弹窗相关
        viewMoreDialogVisible: false,
        viewMoreContent: "",
        factoryNoOverflow: false,
        // 明细拆分弹窗相关
        splitDialogVisible: false,
        splitDetailData: {},
        splitDetailType: "delivery",
        splitList: [],
        ruleValidate: {
          // 定义表格内字段的验证规则
          invoiceContent: [{required: true, message: "请输入开票名称", trigger: "blur"}],
          // unit: [{required: true, message: "请输入单位", trigger: "blur"}],
          quantity: [{required: true, message: "请输入数量", trigger: "blur"}],
          taxTypeCode: [{required: true, message: "请选择税率类型", trigger: "change"}],
          unitPrice: [{required: true, message: "请输入开票单价", trigger: "blur"}],
          totalNetPrice: [{required: true, message: "请输入开票总额(不含税)", trigger: "blur"}],
          totalTaxPrice: [{required: true, message: "请输入税额", trigger: "blur"}],
          taxRate: [{required: true, message: "请输入税率", trigger: "blur"}],
          // invoiceType: [{required: true, message: "请选择发票类型", trigger: "change"}],
          // invoiceStatus: [{required: true, message: "请选择发票状态", trigger: "change"}],
          // referencecode: [{required: true, message: "请输入红字发票号码", trigger: "blur"}],
        },
      };
    },

    watch: {
      $route: {
        handler: function(val) {
          this.getTypeCode();
          if (val.name === "InvoiceApplicationPreview") {
            this.isEdit = false;
            this.getData(this.$route.query.billId, this.$route.query.selection, this.$route.query.cancelId);
          } else if (val.name === "InvoiceApplicationEdit") {
            this.isEdit = true;
            this.getEditData(this.$route.query.billId);
          }
          // 检查出厂编号是否溢出
          this.checkFactoryNoOverflow();
        },
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getTypeCode();
        if (this.$route.name === "InvoiceApplicationPreview") {
          this.isEdit = false;
          this.getData(this.$route.query.billId, this.$route.query.selection, this.$route.query.cancelId);
        } else if (this.$route.name === "InvoiceApplicationEdit") {
          this.isEdit = true;
          this.getEditData(this.$route.query.billId);
        }
        // 检查出厂编号是否溢出
        this.checkFactoryNoOverflow();
      });
    },
    updated() {
      this.$nextTick(() => {
        this.checkFactoryNoOverflow();
      });
    },
    methods: {
      // 切换关联发货单列表的折叠状态
      toggleDeliveryListCollapse() {
        this.deliveryListCollapsed = !this.deliveryListCollapsed;
      },
      // 切换关联销售订单列表的折叠状态
      toggleSaleOrderListCollapse() {
        this.saleOrderListCollapsed = !this.saleOrderListCollapsed;
      },
      // 切换开票信息列表的折叠状态
      toggleDetailsListCollapse() {
        this.detailsListCollapsed = !this.detailsListCollapsed;
      },
      // 处理折扣项
      handleDiscountItem(dragData, targetRow, sourceType, rowIndex) {
        // 计算折扣金额
        const discountAmount = dragData.totalPrice;
        // 如果目标行没有折扣属性，初始化
        if (!targetRow.discount) {
          targetRow.discount = 0;
        }
        // 如果目标行没有折扣属性，初始化
        if (!targetRow.discountTaxPrice) {
          targetRow.discountTaxPrice = 0;
        }
        // 添加折扣
        targetRow.discount += discountAmount;
        this.calculateDiscountTaxPrice(targetRow);
        this.mergeToChild(dragData, targetRow, sourceType, rowIndex);
      },
      // 根据拖拽的数据，放置到开票明细中时，放置到哪个明细表中
      setInvoiceChildItem(sourceType, targetRow, dragData) {
        const childListName = sourceType === "saleOrder" ? "saleOrderList" : "deliveryList";
        // 如果目标行没有子级数据数组，初始化
        if (!targetRow[childListName]) {
          targetRow[childListName] = [];
        }
        if (targetRow.type === "汇总") {
          const countList = [...(targetRow.saleOrderList || []), ...(targetRow.deliveryList || [])]; // 将原有的item先存起来
          if (sourceType === "saleOrder") {
            countList.push(this.addSaleOrderCommonItem(dragData));
          } else {
            countList.push(this.addDeliveryCommonItem(dragData));
          }
          targetRow.countList = countList;
        } else {
          // 添加拖拽数据到子级
          if (sourceType === "saleOrder") {
            targetRow[childListName].push({
              ...this.addSaleOrderCommonItem({...dragData}),
              type: "销售订单",
            });
          } else {
            targetRow[childListName].push({
              ...this.addDeliveryCommonItem({...dragData}),
              type: "发货单",
            });
          }
        }
      },
      mergeToChild(dragData, targetRow, sourceType) {
        const isSameType = (targetRow.type === "销售订单" && sourceType === "saleOrder") || (targetRow.type === "发货单" && sourceType === "delivery");
        if (!isSameType) {
          targetRow.type = "汇总";
        }
        this.setInvoiceChildItem(sourceType, targetRow, dragData);
      },
      // 合并到子级数据
      mergeToChildData(dragData, targetRow, sourceType, rowIndex) {
        // 确定子级数据数组的名称
        const childListName = sourceType === "saleOrder" ? "saleOrderList" : "deliveryList";
        const isSameType = (targetRow.type === "销售订单" && sourceType === "saleOrder") || (targetRow.type === "发货单" && sourceType === "delivery");
        if (!isSameType) {
          if (!targetRow.type) {
            // 类型为空，说明是通过添加按钮新增的开票明细
            let invoiceContent = dragData.sapProductName;
            if (this.form.softInfo === 1) {
              invoiceContent = `${dragData.sapProductName}(${dragData.softInfo})`;
            }
            // 创建新的目标行对象
            const newTargetRow = {
              ...this.addInvoiceCommonItem({...dragData, invoiceContent}),
              type: sourceType === "saleOrder" ? "销售订单" : "发货单",
              quantity: 0,
            };

            // 更新局部变量targetRow以指向新对象
            targetRow = newTargetRow;
          } else {
            targetRow.type = "汇总";
          }
        }
        this.setInvoiceChildItem(sourceType, targetRow, dragData);
        // 合并父级的数量和金额
        this.mergeParentAmounts(dragData, targetRow, rowIndex);
      },
      // 合并父级的数量和金额
      mergeParentAmounts(dragData, targetRow, rowIndex) {
        // 合并数量
        if (!targetRow.quantity) {
          targetRow.quantity = 0;
        }
        targetRow.quantity += dragData.quantity;
        this.handleInvoiceCountChange(targetRow);
        // 使用Vue的$set方法更新form.details数组中的对象
        this.$set(this.form.details, rowIndex, targetRow);
      },
      // 获取行键值
      getRowKey() {
        // 结合时间戳、随机数和计数器，确保唯一性
        if (!this.rowKeyCounter) {
          this.rowKeyCounter = 0;
        }
        this.rowKeyCounter++;
        return new Date().getTime().toString() + Math.floor(Math.random() * 10000) + this.rowKeyCounter;
      },
      // 添加发货单明细的通用字段
      addDeliveryCommonItem(item, invoiceContent) {
        return {
          invoiceContent: invoiceContent || "",
          materialNo: item.materialNo,
          materialName: item.materialName,
          specifications: item.specifications,
          manufacturerModel: item.manufacturerModel,
          sapProductName: item.sapProductName,
          softInfo: item.softInfo,
          unit: item.unit,
          quantity: item.quantity,
          initQuantity: item.initQuantity,
          unitPrice: item.unitPrice,
          totalNetPrice: item.totalNetPrice,
          totalPrice: parseFloat(item.quantity * item.unitPrice).toFixed(2),
          totalTaxPrice: parseFloat(item.totalPrice - item.totalNetPrice).toFixed(2),
          note: item.note || "",
          taxRate: item.taxRate || (item.taxRate == 0 ? 0 : 13),
          rowIndex: item.rowIndex,
          billNo: item.billNo,
          type: "发货单",
          deliveryBillId: item.deliveryBillId,
          deliveryDetailId: item.deliveryDetailId,
          sapSaleOrderNo: item.sapSaleOrderNo,
          salesOrderRowIndex: item.salesOrderRowIndex,
        };
      },
      // 添加发货单明细的通用字段
      addSaleOrderCommonItem(item, invoiceContent) {
        return {
          invoiceContent: invoiceContent || "",
          materialNo: item.materialNo,
          materialName: item.materialName,
          specifications: item.specifications,
          manufacturerModel: item.manufacturerModel,
          sapProductName: item.sapProductName,
          softInfo: item.softInfo,
          unit: item.unit,
          quantity: item.quantity,
          initQuantity: item.initQuantity,
          unitPrice: item.unitPrice,
          totalNetPrice: item.totalNetPrice,
          totalPrice: parseFloat(item.quantity * item.unitPrice).toFixed(2),
          totalTaxPrice: parseFloat(item.totalPrice - item.totalNetPrice).toFixed(2),
          note: item.note || "",
          taxRate: item.taxRate || (item.taxRate == 0 ? 0 : 13),
          rowIndex: item.rowIndex,
          billNo: item.billNo,
          type: "销售订单",
          saleOrderId: item.saleOrderId,
          saleOrderDetailId: item.saleOrderDetailId,
          sapSaleOrderNo: item.sapSaleOrderNo,
          salesOrderRowIndex: item.salesOrderRowIndex,
        };
      },
      // 添加明细开票的通用字段
      addInvoiceCommonItem(item, invoiceContent) {
        const discount = item.discount || 0;
        const discountNetPrice = item.discountNetPrice || discount / (1 + item.taxRate / 100);
        const discountTaxPrice = discount - discountNetPrice;
        const totalPrice = parseFloat(item.totalPrice) || 0;
        const totalNetPrice = parseFloat(item.totalNetPrice) || 0;
        const totalTaxPrice = parseFloat(item.totalPrice) - parseFloat(item.totalNetPrice) || 0;
        const finalTotalPrice = parseFloat(totalPrice) + parseFloat(discount);
        const finalTotalNetPrice = parseFloat(totalNetPrice) + parseFloat(discountNetPrice);
        const finalTotalTaxPrice = parseFloat(finalTotalPrice) - parseFloat(finalTotalNetPrice);
        return {
          invoiceContent: invoiceContent || "",
          // materialNo: item.materialNo || "",
          // materialName: item.materialName || "",
          specifications: item.manufacturerModel || "",
          manufacturerModel: item.manufacturerModel || "",
          sapProductName: item.sapProductName || "",
          unit: item.unit || "",
          softInfo: item.softInfo || "",
          quantity: item.quantity || 1,
          initQuantity: item.initQuantity || 1,
          unitPrice: item.unitPrice || "",
          totalPrice: totalPrice.toFixed(2),
          totalNetPrice: totalNetPrice.toFixed(2),
          totalTaxPrice: totalTaxPrice.toFixed(2),
          finalTotalPrice: finalTotalPrice.toFixed(2),
          finalTotalTaxPrice: finalTotalTaxPrice.toFixed(2),
          finalTotalNetPrice: finalTotalNetPrice.toFixed(2),
          discount: discount || 0,
          discountTaxPrice: discountTaxPrice || 0,
          taxRate: item.taxRate || (item.taxRate == 0 ? 0 : 13),
          // note: item.note || "",
          type: item.type || "",
          rowIndex: item.rowIndex || "",
          billNo: item.billNo || "",
          sapSaleOrderNo: item.sapSaleOrderNo || "",
          salesOrderRowIndex: item.salesOrderRowIndex || "",
          taxTypeCode: item.taxTypeCode || "",
          taxTypeName: item.taxTypeName || "",
          remoteOptions: item.taxTypeCode ? [{
            taxTypeCode: item.taxTypeCode || "",
            taxTypeName: item.taxTypeName || "",
          }] : [],
          selectLoading: false,
          rowKey: item.rowKey || this.getRowKey(), // 唯一键值
        };
      },
      // 处理开票信息明细选择变化
      handleDetailsSelectionChange(selection) {
        this.selectedDetails = selection;
      },
      // 显示查看更多弹窗
      showViewMoreDialog(content) {
        this.viewMoreContent = content;
        this.viewMoreDialogVisible = true;
      },
      // 关闭查看更多弹窗
      closeViewMoreDialog() {
        this.viewMoreDialogVisible = false;
        this.viewMoreContent = "";
      },
      // 检查出厂编号是否溢出
      checkFactoryNoOverflow() {
        if (this.$refs.factoryNoContainer) {
          this.factoryNoOverflow = this.$refs.factoryNoContainer.scrollHeight >= 35;
        }
      },
      // 批量删除选中的开票信息明细
      batchDeleteDetails() {
        // 如果没有选中任何明细，提示用户
        if (this.selectedDetails.length === 0) {
          this.$message.warning("请先选择要删除的明细");
          return;
        }

        // 按索引从大到小排序，避免删除时索引变化的问题
        const selectedIndices = this.selectedDetails
          .map(row => this.form.details.findIndex(item => item.rowKey === row.rowKey))
          .sort((a, b) => b - a);

        // 执行删除操作
        selectedIndices.forEach(index => {
          const row = this.form.details[index];
          this.deleteRow(index, "detail", row);
        });

        // 清空选择
        this.selectedDetails = [];
      },
      // 删除明细行
      deleteRow(index, type, row) {
        let params = {};
        switch (type) {
          case "delivery":
            this.allList = [...this.deliveryList, ...this.saleOrderList];
            this.deliveryList.splice(index, 1);
            this.calculateBaseTotalAmount(row, "delete");
            break;
          case "saleOrder":
            this.allList = [...this.deliveryList, ...this.saleOrderList];
            this.saleOrderList.splice(index, 1);
            this.calculateBaseTotalAmount(row, "delete");
            break;
          case "detail":
            // 检查是否是拆分后的明细
            if (row.originalData) {
              // 找出所有相关的拆分明细
              const relatedDetails = this.form.details.filter(detail =>
                detail.originalData &&
                detail.splitParentId === row.splitParentId,
              );

              // 创建还原数据
              const originalRow = row.originalData;

              // 根据类型还原到原列表
              if (row.type === "发货单") {
                params = this.addDeliveryCommonItem(originalRow);
                this.deliveryList.push(params);
              } else if (row.type === "销售订单") {
                params = this.addSaleOrderCommonItem(originalRow);
                this.saleOrderList.push(params);
              } else if (row.type === "汇总") {
                if (originalRow.type === "销售订单") {
                  params = this.addSaleOrderCommonItem(originalRow);
                  this.saleOrderList.push(params);
                } else {
                  params = this.addDeliveryCommonItem(originalRow);
                  this.deliveryList.push(params);
                }
              }
              // 如果不是通过拆分明细生成的明细行，则需要重置到关联列表中去
              relatedDetails.forEach((item) => {
                if (item.deliveryList && item.deliveryList.length > 0) {
                  item.deliveryList.forEach((delItem) => {
                    if (!delItem.splitParentId) {
                      params = this.addDeliveryCommonItem(delItem);
                      this.deliveryList.push(params);
                    }
                  });
                }
                if (item.saleOrderList && item.saleOrderList.length > 0) {
                  item.saleOrderList.forEach((salItem) => {
                    if (!salItem.splitParentId) {
                      // 如果不是拆分过来的
                      params = this.addSaleOrderCommonItem(salItem);
                      this.saleOrderList.push(params);
                    }
                  });
                }
                if (item.countList && item.countList.length > 0) {
                  item.countList.forEach((countItem) => {
                    if (!countItem.splitParentId) {
                      if (countItem.type === "销售订单") {
                        params = this.addSaleOrderCommonItem(countItem);
                        this.saleOrderList.push(params);
                      } else {
                        params = this.addDeliveryCommonItem(countItem);
                        this.deliveryList.push(params);
                      }
                    }
                  });
                }
              });

              // 从details中删除所有相关的拆分明细
              relatedDetails.forEach(detail => {
                const detailIndex = this.form.details.indexOf(detail);
                if (detailIndex > -1) {
                  this.form.details.splice(detailIndex, 1);
                }
              });
              // 重新计算开票信息明细的合计值
              this.calculateDetailsTotalAmount();
            } else {
              if (row.type === "发货单") {
                if (row.deliveryList && row.deliveryList.length > 0) {
                  row.deliveryList.forEach((item) => {
                    params = this.addDeliveryCommonItem(item);
                    this.deliveryList.push(params);
                  });
                }
              } else if (row.type === "销售订单") {
                if (row.saleOrderList && row.saleOrderList.length > 0) {
                  row.saleOrderList.forEach((item) => {
                    params = this.addSaleOrderCommonItem(item);
                    this.saleOrderList.push(params);
                  });
                }
              } else {
                if (row.countList) {
                  row.countList.forEach((item) => {
                    if (item.type === "销售订单") {
                      params = this.addSaleOrderCommonItem(item);
                      this.saleOrderList.push(params);
                    } else {
                      params = this.addDeliveryCommonItem(item);
                      this.deliveryList.push(params);
                    }
                  });
                }
              }
              this.form.details.splice(index, 1);
              // 重新计算开票信息明细的合计值
              this.calculateDetailsTotalAmount();
            }
            break;
        }
      },
      clearForm() {
        this.form = {
          invoiceApplicationNo: "",
          customerId: "",
          customerName: "",
          customerNo: "",
          invoiceVATNO: "",
          invoiceAddress: "",
          invoiceAccounts: "",
          financialVouchers: "",
          email: "",
          invoiceTotalAmount: "",
          note: "",
          details: [],
          totalNetPrice: "",
          totalTaxPrice: "",
          // 新增开票信息部分的合计值字段
          detailsTotalNetPrice: 0,
          detailsTotalTaxPrice: 0,
          detailsInvoiceTotalAmount: 0,
          invoiceType: "05",
          invoiceStatus: "1",
          referencecode: "",
          softInfo: "",
        };
      },
      // 将接口返回的数据进行处理, 主要存储一个initQuantity数量，以及计算最终开票金额等
      handleApiData(resp) {
        this.form = resp;
        // 为开票信息部分的合计值字段设置默认值0
        this.$set(this.form, "detailsTotalNetPrice", this.form.detailsTotalNetPrice || 0);
        this.$set(this.form, "detailsTotalTaxPrice", this.form.detailsTotalTaxPrice || 0);
        this.$set(this.form, "detailsInvoiceTotalAmount", this.form.detailsInvoiceTotalAmount || 0);
        this.deliveryList = resp.deliveryList.map((item) => {
          this.$set(item, "taxRate", item.taxRate || (item.taxRate == 0 ? 0 : 13));
          item.initQuantity = item.quantity;
          return item;
        });
        this.saleOrderList = resp.saleOrderList.map((item) => {
          this.$set(item, "taxRate", item.taxRate || (item.taxRate == 0 ? 0 : 13));
          item.initQuantity = item.quantity;
          return item;
        });
        this.allList = [...this.deliveryList, ...this.saleOrderList];
        if (this.form.details.length > 0) {
          this.form.details.forEach((item) => {
            // 为接口返回的没有discount字段的数据添加默认值
            this.$set(item, "rowKey", item.rowKey || this.getRowKey());
            this.$set(item, "discount", item.discount || 0);
            this.$set(item, "discountNetPrice", parseFloat(item.discountNetPrice) || parseFloat(item.discount / (1 + item.taxRate / 100)).toFixed(2));
            this.$set(item, "discountTaxPrice", parseFloat(item.discount - item.discountNetPrice).toFixed(2));
            this.$set(item, "taxRate", item.taxRate || (item.taxRate == 0 ? 0 : 13));
            this.$set(item, "selectLoading", false);
            this.$set(item, "remoteOptions", item.taxTypeCode ? [{
              taxTypeCode: item.taxTypeCode || "",
              taxTypeName: item.taxTypeName || "",
            }] : []);
            this.$set(item, "totalTaxPrice", (parseFloat(item.totalPrice) - parseFloat(item.totalNetPrice)).toFixed(2));
            if (item.type === "汇总") {
              item.countList = item.deliveryList.concat(item.saleOrderList);
            }
            this.calcuteItemFinalPrice(item);
          });
          // 计算并更新开票信息明细的合计值
          this.calculateDetailsTotalAmount();
        }
        this.form.invoiceType = this.form.invoiceType || "05";
        this.judgeInvoiceContent();
        this.contentLoading = false;
      },
      getData(id, selection, cancelId) {
        this.contentLoading = true;
        // 一个是开票预览，一个是开票申请，所以根据地址上的参数不一样，调用接口不同
        if (id > 0) {
          this.edit = 0;
          this.$http.get("basic", "invoiceApplication/" + id).then((resp) => {
            this.handleApiData(resp);
          });
        } else if (cancelId > 0) {
          this.edit = 1;
          this.$http.get("basic", `invoiceApplication/getCancelApplication/${cancelId}`)
            .then((resp) => {
              this.handleApiData(resp);
            });
        } else {
          this.edit = 1;
          // 从列表中带入信息开票
          if (selection.length > 0) {
            this.$http.post("basic", "invoiceApplication/getApplication", selection).then((resp) => {
              this.handleApiData(resp);
            });
          } else {
            // 如果没有带入数据，则需要清空数据
            this.clearForm();
            this.contentLoading = false;
          }
        }
      },
      getEditData(id) {
        this.contentLoading = true;
        this.$http.get("basic", "invoiceApplication/" + id).then((resp) => {
          this.handleApiData(resp);
        });
      },
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        let url = "";
        console.log(this.form);
        if (this.form.pkid > 0) {
          url = "invoiceApplication/upload/" + this.form.pkid;
        } else {
          url = "file/upload";
        }
        this.$http
          .post("basic", url, formData)
          .then((res) => {
            this.uploadLoading = false;
            this.form.accessoryList.push({
              fileName: res.originalName,
              filePath: res.fullPath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });

      },
      // 校验发货单列表和销售订单的含税金额总和是否等于明细清单的含税金额总和
      validateInvoiceAmount() {
        // 计算父级明细的开票总额（含税）总和
        let detailsTotalPrice = 0;
        this.form.details.forEach((item) => {
          detailsTotalPrice += parseFloat(item.totalPrice) + parseFloat(item.discount);
        });
        let hasFaxIsZero = this.form.details.some(item => Number(item.taxRate) === 0); // 开票税率只要有一个为0，则不走0.5那个校验了
        if (hasFaxIsZero) {
          return true;
        }
        // 校验父级明细总和与基本信息中的开票金额是否相等
        if (Math.abs(detailsTotalPrice - parseFloat(this.form.invoiceTotalAmount)) > 0.5) {
          this.$message.error("开票信息明细的开票总额（含税）总和与基本信息中的开票金额差额超出0.5元，请检查！");
          return false;
        }
        return true;
      },
      saveHandle() {
        if (this.form.details.length <= 0) {
          return this.$message.error("开票信息不能为空！");
        }

        // 验证所有表格和表单
        Promise.all([
          new Promise((resolve) => {
            if (this.$refs.deliveryForm) {
              this.$refs.deliveryForm.validate(resolve);
            } else {
              resolve(true);
            }
          }),
          new Promise((resolve) => {
            if (this.$refs.saleOrderForm) {
              this.$refs.saleOrderForm.validate(resolve);
            } else {
              resolve(true);
            }
          }),
          new Promise((resolve) => {
            this.$refs.detailsForm.validate(resolve);
          }),
          new Promise((resolve) => {
            this.$refs.Form.validate(resolve);
          }),
        ]).then(([deliveryValid, saleOrderValid, detailsValid, formValid]) => {
          if (deliveryValid && saleOrderValid && detailsValid && formValid) {
            // 验证通过，继续执行保存逻辑
            if (!this.validateInvoiceAmount()) {
              return false;
            }
            // 处理发货单列表
            if (this.deliveryList && this.deliveryList.length > 0) {
              this.form.deliveryList = this.deliveryList;
            } else {
              delete this.form.deliveryList;
            }
            // 处理销售订单列表
            if (this.saleOrderList && this.saleOrderList.length > 0) {
              this.form.saleOrderList = this.saleOrderList;
            } else {
              delete this.form.saleOrderList;
            }
            if (this.form.details.length > 0) {
              this.form.details.forEach((item) => {
                if (item.type === "汇总") {
                  let deliveryList = [];
                  let saleOrderList = [];
                  item.countList.forEach((item2) => {
                    if (item2.type === "销售订单") {
                      saleOrderList.push(item2);
                    } else {
                      deliveryList.push(item2);
                    }
                  });
                  item.deliveryList = deliveryList;
                  item.saleOrderList = saleOrderList;
                }
              });
            }
            this.submitLoading = true;
            // 页面上删除这几个字段
            this.form.details.forEach((item) => {
              delete item.note;
              delete item.materialName;
              delete item.materialNo;
            });
            if (this.isEdit) {
              this.$http.put("basic", "invoiceApplication", this.form).then(() => {
                this.submitLoading = false;
                this.$bus.$emit("closeTag", this.$route);
                this.$router.push({
                  path: "/invoicingManagement/invoiceApplication/InvoiceApplicationList",
                });
              }).catch(() => {
                this.$message.error("更新失败");
                this.submitLoading = false;
              });
            } else {
              this.$http.post("basic", "invoiceApplication", this.form)
                .then(() => {
                  // 关闭标签
                  this.submitLoading = false;
                  this.$bus.$emit("closeTag", this.$route);
                  this.$router.push({
                    path: "/invoicingManagement/invoiceApplication/ToDoInvoiceList",
                  });
                }).catch(() => {
                  this.$message.error("保存失败");
                  this.submitLoading = false;
                });
            }
          } else {
            // 验证失败
            this.$message.error("请检查表单和表格中的必填项！");
            return false;
          }
        });
      },
      submit() {
        // 验证所有表格和表单
        Promise.all([
          new Promise((resolve) => {
            if (this.$refs.deliveryForm) {
              this.$refs.deliveryForm.validate(resolve);
            } else {
              resolve(true);
            }
          }),
          new Promise((resolve) => {
            if (this.$refs.saleOrderForm) {
              this.$refs.saleOrderForm.validate(resolve);
            } else {
              resolve(true);
            }
          }),
          new Promise((resolve) => {
            this.$refs.detailsForm.validate(resolve);
          }),
          new Promise((resolve) => {
            this.$refs.Form.validate(resolve);
          }),
        ]).then(([deliveryValid, saleOrderValid, detailsValid, formValid]) => {
          if (deliveryValid && saleOrderValid && detailsValid && formValid) {
            if (!this.validateInvoiceAmount()) {
              return false;
            }
            // 验证通过，继续执行提交逻辑
            // this.$http.post("basic", "invoiceApplications/saveAndSubmit", this.form)
            //   .then(() => {
            //     // 关闭标签
            //     this.$bus.$emit("closeTag", this.$route);
            //     this.$router.push({
            //       path: "/SalesManage/InvoiceApplication/ToDoInvoiceList",
            //     });
            //   }).catch(() => {
            //     this.$message.error("保存失败");
            //     this.submitLoading = false;
            //   });
          } else {
            // 验证失败
            this.$message.error("请检查表单和表格中的必填项！");
            return false;
          }
        });
      },
      // 开票信息 - 添加
      addInvoiceDetails() {
        let obj = {
          ...this.addInvoiceCommonItem({}),
        };
        this.form.details.push(obj);
        // 重新计算开票信息明细的合计值
        this.calculateDetailsTotalAmount();
      },
      // 明细拆分相关方法
      splitDetail(row, type) {
        this.splitDetailData = JSON.parse(JSON.stringify(row));
        this.splitDetailType = type;
        this.splitDialogVisible = true;
      },
      // 拆分明细 - 确认添加到开票信息中
      handleSplitConfirm(splitDetails) {
        let rowKey;
        // 处理拆分后的数据
        splitDetails.forEach((splitItem) => {
          rowKey = this.getRowKey();
          let invoiceContent = splitItem.sapProductName;
          if (this.form.softInfo === 1) {
            invoiceContent = `${splitItem.sapProductName}(${splitItem.softInfo})`;
          }

          if (this.splitDetailType === "delivery") {
            // 发货单明细
            this.form.details.push({
              ...splitItem,
              ...this.addInvoiceCommonItem({
                ...splitItem.originalData, ...splitItem,
                invoiceContent,
                rowKey,
                specifications: splitItem.manufacturerModel,
              }),
              deliveryList: [{...this.addDeliveryCommonItem(splitItem.originalData, ""), ...splitItem}],
            });
          } else {
            // 销售订单明细
            this.form.details.push({
              ...splitItem,
              ...this.addInvoiceCommonItem({
                ...splitItem.originalData, ...splitItem,
                invoiceContent,
                rowKey,
                specifications: splitItem.manufacturerModel,
              }),
              saleOrderList: [{...this.addSaleOrderCommonItem(splitItem.originalData, ""), ...splitItem}],
            });
          }
        });

        // 从原列表中移除该明细
        if (this.splitDetailType === "delivery") {
          const index = this.deliveryList.findIndex(item => item.deliveryDetailId === this.splitDetailData.deliveryDetailId);
          if (index > -1) {
            this.deliveryList.splice(index, 1);
          }
        } else {
          const index = this.saleOrderList.findIndex(item => item.saleOrderDetailId === this.splitDetailData.saleOrderDetailId);
          if (index > -1) {
            this.saleOrderList.splice(index, 1);
          }
        }

        // 更新开票金额
        this.calculateDetailsTotalAmount();
        this.splitDialogVisible = false;
      },
      // 计算开票明细中的实际税额
      /**
       *
       * 实际开票金额（含税） = 开票总额（含税） + 折扣额（含税），其中折扣额是负数，所以要相加
       * 实际税额 = 税额 + 折扣税额 ，其中折扣税额是负数，所以要相加
       * 实际开票金额（不含税） = 实际开票金额（含税）- 实际税额
       */
      calcuteItemFinalPrice(row) {
        // 确保所有值都被正确转换为数字
        const discount = parseFloat(row.discount) || 0;
        const totalPrice = parseFloat(row.totalPrice) || 0;
        const totalNetPrice = parseFloat(row.totalNetPrice) || 0;
        const discountNetPrice = parseFloat(row.discountNetPrice) || discount / (1 + row.taxRate / 100);
        // 计算明细行的实际开票金额（含税） = 开票总额（含税） + 折扣额（含税）
        row.finalTotalPrice = (totalPrice + discount).toFixed(2);
        // 计算明细行的实际开票金额（不含税） = 实际开票金额（含税） - 实际税额
        row.finalTotalNetPrice = (totalNetPrice + discountNetPrice).toFixed(2);
        // 计算明细行的实际税额 = 税额 + 折扣税额
        row.finalTotalTaxPrice = parseFloat(row.finalTotalPrice - row.finalTotalNetPrice).toFixed(2);
        // 确保结果是有效的数字
        if (isNaN(row.finalTotalPrice)) row.finalTotalPrice = 0;
        if (isNaN(row.finalTotalTaxPrice)) row.finalTotalTaxPrice = 0;
        if (isNaN(row.finalTotalNetPrice)) row.finalTotalNetPrice = 0;
        // 重新计算开票信息明细的合计值
        this.calculateDetailsTotalAmount();
      },
      // 计算折扣税额
      calculateDiscountTaxPrice(row) {
        // 根据输入的折扣额计算折扣税额
        // 折扣税额 = 折扣额(含税) - 折扣额(不含税)
        const discount = parseFloat(row.discount) || 0;
        const taxRate = parseFloat(row.taxRate) || 0;
        const taxRateDecimal = taxRate / 100;
        row.discountNetPrice = parseFloat(discount / (1 + taxRateDecimal)).toFixed(2);
        row.discountTaxPrice = parseFloat(discount - row.discountNetPrice).toFixed(2);
        this.calcuteItemFinalPrice(row);
      },
      // 税率改变时，对应税额 折扣税额进行联动
      handleInvoiceTaxChange(row) {
        row.totalNetPrice = (row.totalPrice / (1 + row.taxRate / 100)).toFixed(2); // 开票金额总价(不含税) = 开票金额总价(含税) / (1 + 税率)
        row.totalTaxPrice = (row.totalPrice - row.totalNetPrice).toFixed(2); // 开票金额税额 = 开票金额总价(含税) - 开票金额总价(不含税)
        this.calculateDiscountTaxPrice(row);
      },
      // 开票数量和开票单价改变时，对应开票金额，税额，及最终开票金额等进行联动
      handleInvoiceCountChange(row) {
        if (!row.quantity || !row.unitPrice) {
          row.totalPrice = "";
          row.totalNetPrice = "";
          row.totalTaxPrice = "";
          return;
        }
        row.totalPrice = (parseFloat(row.quantity) * parseFloat(row.unitPrice)).toFixed(2); // 开票金额总价(含税) = 开票单价 * 开票数量
        row.totalNetPrice = (parseFloat(row.totalPrice) / parseFloat(1 + row.taxRate / 100)).toFixed(2); // 开票金额总价(不含税) = 开票金额总价(含税) / (1 + 税率)
        row.totalTaxPrice = (parseFloat(row.totalPrice) - parseFloat(row.totalNetPrice)).toFixed(2); // 开票金额税额 = 开票金额总价(含税) - 开票金额总价(不含税)
        this.calcuteItemFinalPrice(row);
      },
      // 开票总额(不含税) / 税额改变时，对应开票金额税额进行联动
      calculateInvoiceTotalPrice(row) {
        if (!row.totalNetPrice || !row.totalTaxPrice) {
          row.totalPrice = "";
          return;
        }
        row.totalPrice = (parseFloat(row.totalTaxPrice) + parseFloat(row.totalNetPrice)).toFixed(2);
        this.calcuteItemFinalPrice(row);
      },
      invoiceContentChange(row) {
        console.log(row);

        if (this.form.softInfo === 1) {
          if (!row.invoiceContent.includes(row.softInfo)) {
            row.invoiceContent = `${row.invoiceContent}(${row.softInfo})`;
          }
        }
      },
      // 判断开票总金额的值，对应给发票状态赋值
      judgeInvoiceContent() {
        // 根据发票总金额自动设置发票状态
        if (this.form.invoiceTotalAmount > 0) {
          this.form.invoiceStatus = "1"; // 蓝票
        } else if (this.form.invoiceTotalAmount < 0) {
          this.form.invoiceStatus = "2"; // 红票
        }
        // 如果invoiceTotalAmount为0，则保持原发票状态
      },
      // 根据发货列表/销售订单列表计算基本信息中的开票总金额
      calculateBaseTotalAmount(row, type) {
        // 存储原始列表行，用于计算基本信息中的金额
        if (type === "change") {
          // 更新allList中对应行的数据
          // 先在deliveryList中查找
          if (row.deliveryDetailId) {
            const deliveryIndex = this.allList.findIndex(item => item.deliveryDetailId === row.deliveryDetailId);
            this.$set(this.allList, deliveryIndex, row);
          } else {
            // 再在saleOrderList中查找
            const saleOrderIndex = this.allList.findIndex(item => item.saleOrderDetailId === row.saleOrderDetailId);
            if (saleOrderIndex !== -1) {
              this.$set(this.allList, saleOrderIndex, row);
            }
          }
        } else if (type === "delete") {
          // 删除allList中对应的明细
          // 先在deliveryList中查找并删除
          if (row.deliveryDetailId) {
            const deliveryIndex = this.allList.findIndex(item => item.deliveryDetailId === row.deliveryDetailId);
            this.allList.splice(deliveryIndex, 1);
          } else if (row.saleOrderDetailId) {
            // 再在saleOrderList中查找并删除
            const saleOrderIndex = this.allList.findIndex(item => item.saleOrderDetailId === row.saleOrderDetailId);
            if (saleOrderIndex !== -1) {
              this.allList.splice(saleOrderIndex, 1);
            }
          }
        }
        // 计算基本信息中的总金额、总税额、总不含税金额
        let invoiceTotalAmount = 0;
        let totalNetPrice = 0;
        let totalTaxPrice = 0;

        // 计算基本信息里的汇总信息
        this.allList.forEach((item) => {
          const itemTotalPrice = parseFloat(item.totalPrice) || 0;
          const itemTotalNetPrice = parseFloat(item.totalNetPrice) || 0;

          invoiceTotalAmount += itemTotalPrice;
          totalNetPrice += itemTotalNetPrice;
          totalTaxPrice += parseFloat(itemTotalPrice - itemTotalNetPrice); // 税额 = 含税金额 - 不含税金额
        });

        this.form.invoiceTotalAmount = invoiceTotalAmount.toFixed(2);
        this.form.totalNetPrice = totalNetPrice.toFixed(2);
        this.form.totalTaxPrice = totalTaxPrice.toFixed(2);
        this.judgeInvoiceContent();
      },
      // 根据开票信息明细计算开票信息部分的开票总金额
      calculateDetailsTotalAmount() {
        // 计算开票信息部分的总金额、总税额、总不含税金额（基于开票信息明细）
        let detailsInvoiceTotalAmount = 0;
        let detailsTotalNetPrice = 0;

        // 遍历开票信息明细列表
        this.form.details.forEach((item) => {
          const itemTotalPrice = parseFloat(item.totalPrice) || 0;
          const itemTotalNetPrice = parseFloat(item.totalNetPrice) || 0;

          detailsInvoiceTotalAmount += itemTotalPrice;
          detailsTotalNetPrice += itemTotalNetPrice;
        });

        // 更新开票信息部分的合计值
        this.form.detailsInvoiceTotalAmount = detailsInvoiceTotalAmount.toFixed(2);
        this.form.detailsTotalNetPrice = detailsTotalNetPrice.toFixed(2);
        this.form.detailsTotalTaxPrice = parseFloat(detailsInvoiceTotalAmount - detailsTotalNetPrice).toFixed(2);
      },
      // 发货单 / 销售订单明细中的数量或者税率改变时，对应金额等进行联动
      calculateInvoicAmount(row, newVal, type) {
        switch (type) {
          case "quantity":
            this.$set(row, "quantity", newVal);
            break;
          case "taxRate":
            this.$set(row, "taxRate", newVal);
            break;
        }
        // 确保所有计算使用有效的数字值，避免NaN
        const quantity = parseFloat(row.quantity) || 0;
        const unitPrice = parseFloat(row.unitPrice) || 0;
        const taxRateValue = parseFloat(row.taxRate) || 0;
        this.$set(row, "totalPrice", parseFloat(quantity * unitPrice).toFixed(2)); // 开票金额总价(含税) = 开票单价 * 开票数量
        let taxRate = (taxRateValue / 100) + 1; // 税率
        // 避免除以0
        if (taxRate !== 1) {
          this.$set(row, "totalNetPrice", parseFloat(row.totalPrice / taxRate).toFixed(2)); // 开票金额总价(不含税)
        } else {
          this.$set(row, "totalNetPrice", parseFloat(row.totalPrice).toFixed(2)); // 当税率为0时，不含税金额等于含税金额
        }
        this.calculateBaseTotalAmount(row, "change");
      },

      // 选择客户
      selectCustomer(row) {
        this.form.customerName = row.customerName;
        this.form.customerId = row.customerID;
        this.form.customerNo = row.outerNo;
        this.form.invoiceVATNO = row.vatno;
      },

      selectCode(row) {
        // 从远程选项中查找对应的税收分类名称
        if (row.remoteOptions && row.remoteOptions.length > 0) {
          const selectedOption = row.remoteOptions.find(item => item.taxTypeCode === row.taxTypeCode);
          if (selectedOption) {
            row.taxTypeName = selectedOption.taxTypeName;
          }
        }
      },
      handleRemoteSearch(query, row) {
        if (query !== "") {
          row.selectLoading = true;
          // 调用后端接口根据关键字查询税收分类编码
          setTimeout(() => {
            row.remoteOptions = this.typeCodeList.filter(item => {
              return item.taxTypeName.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
            row.selectLoading = false;
          }, 200);
        } else {
          row.remoteOptions = [];
        }
      },

      getTypeCode() {
        this.$http.get("basic", "invoiceTypeCode/selectAllCode")
          .then((resp) =>
            this.typeCodeList = resp);
      },
    },
  };
</script>
<style lang="scss" scoped>
.ReserveOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.ReserveOrderTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
  word-break: break-all;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}

.tableContent {
  width: 340px;
  text-align: left;
  white-space: pre-wrap;
}

.detailTableLabel {
  width: 100px;
  text-align: left;
  background-color: #D1E6F5;
}

table {
  .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }
}

/* 隐藏数字输入框的上下箭头 */
::v-deep {

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

input[type="number"] {
  appearance: textfield;
}


.drag-source {
  opacity: 0.5;
  background-color: #f0f0f0;
}

.drag-target {
  background-color: #e6f7ff;
  border: 1px dashed #1890ff;
}

.collapse-icon {
  display: inline-block;
  transition: transform 0.3s;
}

.collapse-icon.rotate {
  transform: rotate(-90deg);
}

/* 出厂编号显示样式 */
.factory-no-container {
  position: relative;
  max-height: 2.8em;
  line-height: 1.4em;
  overflow: hidden;
}

.factory-no-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
  width: 100%;
}

.view-more-link {
  color: #409EFF;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: white;
  padding: 0 5px;
  z-index: 10;
  line-height: 1.4em;
  text-align: right;
  white-space: nowrap;
  font-size: 14px;
  box-shadow: -5px 0 5px white;
}

.view-more-link:hover {
  color: #66B1FF;
}

/* 查看更多弹窗样式 */
.view-more-content {
  padding: 10px;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 720px;
  overflow-y: auto;
}
</style>
